// src/apiConfig.js
// Change ONLY API_BASE when deploying for another client.
export const API_BASE = "https://manage.spst.in/api";

const clean = (value = "") => String(value).trim().replace(/^\/+/, "");

export const apiUrl = (endpoint = "") => {
  const path = clean(endpoint);
  return path ? `${API_BASE}/${path}` : API_BASE;
};

export const UPLOAD_BASE = `${API_BASE}/uploads`;

export const uploadUrl = (path = "") => {
  if (!path) return "";

  let value = String(path).trim().replace(/\\/g, "/");

  // Convert absolute URLs returned/stored by older versions.
  // Examples:
  // https://sansha.in/uploads/file.pdf
  // https://sansha.in/api/uploads/file.pdf
  if (/^https?:\/\//i.test(value)) {
    try {
      const u = new URL(value);
      value = u.pathname;
    } catch (_) {
      return value;
    }
  }

  value = value.replace(/^\/+/, "");
  value = value.replace(/^api\/uploads\//i, "");
  value = value.replace(/^uploads\//i, "");

  return `${UPLOAD_BASE}/${value}`;
};

// Backward-compatible helper used by existing components.
export const fileUrl = uploadUrl;

// Site-root helper retained for components that may still need it.
export const appUrl = (path = "") => {
  const origin = API_BASE.replace(/\/api\/?$/i, "");
  const value = clean(path);
  return value ? `${origin}/${value}` : origin;
};
